// Multi-language translations for PolyTech Wallet
// Supported languages: ru (Russian), en (English), kg (Kyrgyz)

export const translations = {
  // ===== Navigation =====
  nav: {
    home: { ru: 'Главная', en: 'Home', kg: 'Башкы' },
    history: { ru: 'История', en: 'History', kg: 'Тарых' },
    profile: { ru: 'Профиль', en: 'Profile', kg: 'Профиль' },
  },
  
  // ===== Home / Wallet =====
  home: {
    greeting: { ru: 'Привет', en: 'Hello', kg: 'Салам' },
    multiCurrencyWallet: { ru: 'Мультивалютный кошелёк', en: 'Multi-currency wallet', kg: 'Көп валюталуу капчык' },
    currencies: { ru: 'ВАЛЮТЫ', en: 'CURRENCIES', kg: 'ВАЛЮТАЛАР' },
    exchangeRates: { ru: 'Курсы валют', en: 'Exchange rates', kg: 'Валюта курстары' },
    centralBankRate: { ru: 'Курс ЦБ', en: 'CB Rate', kg: 'БУБ курсу' },
    updatesEvery5min: { ru: 'обновление 5 мин', en: 'updates 5 min', kg: '5 мин жаңырат' },
    recentTransactions: { ru: 'Последние операции', en: 'Recent transactions', kg: 'Акыркы операциялар' },
    allTransactions: { ru: 'Все', en: 'All', kg: 'Баары' },
    noTransactions: { ru: 'Пока нет операций', en: 'No transactions yet', kg: 'Азырынча операциялар жок' },
    topUpBalance: { ru: 'Пополните баланс', en: 'Top up your balance', kg: 'Балансыңызды толтуруңуз' },
  },
  
  // ===== Actions =====
  actions: {
    topUp: { ru: 'Пополнить', en: 'Top up', kg: 'Толуктоо' },
    exchange: { ru: 'Обменять', en: 'Exchange', kg: 'Айырбаштоо' },
    withdraw: { ru: 'Вывести', en: 'Withdraw', kg: 'Чыгаруу' },
    payments: { ru: 'Платежи', en: 'Payments', kg: 'Төлөмдөр' },
    send: { ru: 'Отправить', en: 'Send', kg: 'Жөнөтүү' },
    receive: { ru: 'Получить', en: 'Receive', kg: 'Алуу' },
    continue: { ru: 'Продолжить', en: 'Continue', kg: 'Улантуу' },
    confirm: { ru: 'Подтвердить', en: 'Confirm', kg: 'Ырастоо' },
    cancel: { ru: 'Отмена', en: 'Cancel', kg: 'Жокко чыгаруу' },
    back: { ru: 'Назад', en: 'Back', kg: 'Артка' },
    copy: { ru: 'Скопировать', en: 'Copy', kg: 'Көчүрүү' },
    copied: { ru: 'Скопировано', en: 'Copied', kg: 'Көчүрүлдү' },
    close: { ru: 'Закрыть', en: 'Close', kg: 'Жабуу' },
    save: { ru: 'Сохранить', en: 'Save', kg: 'Сактоо' },
    apply: { ru: 'Применить', en: 'Apply', kg: 'Колдонуу' },
  },
  
  // ===== Currencies =====
  currencies: {
    USD: { ru: 'Доллар', en: 'Dollar', kg: 'Доллар' },
    KGS: { ru: 'Сом', en: 'Som', kg: 'Сом' },
    EUR: { ru: 'Евро', en: 'Euro', kg: 'Евро' },
    MDL: { ru: 'Лей', en: 'Leu', kg: 'Лей' },
    KZT: { ru: 'Тенге', en: 'Tenge', kg: 'Теңге' },
    RUB: { ru: 'Рубль', en: 'Ruble', kg: 'Рубль' },
  },
  
  // ===== Verification / KYC =====
  kyc: {
    verification: { ru: 'Верификация', en: 'Verification', kg: 'Верификация' },
    status: {
      notStarted: { ru: 'Не пройдена', en: 'Not started', kg: 'Башталган эмес' },
      inProgress: { ru: 'В процессе', en: 'In progress', kg: 'Жүрүп жатат' },
      pending: { ru: 'На проверке', en: 'Pending review', kg: 'Текшерүүдө' },
      approved: { ru: 'Подтверждена', en: 'Approved', kg: 'Ырасталды' },
      rejected: { ru: 'Отклонена', en: 'Rejected', kg: 'Четке кагылды' },
    },
    passKYC: { ru: 'Пройти верификацию', en: 'Complete verification', kg: 'Верификацияны өтүү' },
    continueKYC: { ru: 'Продолжить верификацию', en: 'Continue verification', kg: 'Верификацияны улантуу' },
    forWithdrawal: { ru: 'Пройдите KYC для вывода', en: 'Complete KYC for withdrawals', kg: 'Чыгаруу үчүн KYC өтүңүз' },
    continueCheck: { ru: 'Продолжите KYC проверку', en: 'Continue KYC verification', kg: 'KYC текшерүүнү улантыңыз' },
    creatingSession: { ru: 'Создаём сессию верификации...', en: 'Creating verification session...', kg: 'Верификация сессиясын түзүүдө...' },
    openNewTab: { ru: 'Откройте новую вкладку для верификации', en: 'Open new tab for verification', kg: 'Верификация үчүн жаңы өтмөк ачыңыз' },
    alreadyPassed: { ru: 'Верификация уже пройдена!', en: 'Verification already completed!', kg: 'Верификация мурунтан эле өтүлгөн!' },
    sessionError: { ru: 'Ошибка создания сессии', en: 'Session creation error', kg: 'Сессия түзүү катасы' },
  },
  
  // ===== Profile =====
  profile: {
    title: { ru: 'Профиль', en: 'Profile', kg: 'Профиль' },
    pin: {
      title: { ru: 'PIN-код', en: 'PIN code', kg: 'PIN код' },
      set: { ru: 'Установлен', en: 'Set', kg: 'Коюлган' },
      notSet: { ru: 'Не установлен', en: 'Not set', kg: 'Коюлган эмес' },
      setPin: { ru: 'Установить PIN-код', en: 'Set PIN code', kg: 'PIN код коюу' },
      changePin: { ru: 'Изменить PIN-код', en: 'Change PIN code', kg: 'PIN кодду өзгөртүү' },
      enterPin: { ru: 'Введите PIN-код', en: 'Enter PIN code', kg: 'PIN кодду киргизиңиз' },
      repeatPin: { ru: 'Повторите PIN-код', en: 'Repeat PIN code', kg: 'PIN кодду кайталаңыз' },
      create4Digit: { ru: 'Придумайте 4-значный PIN-код для защиты операций', en: 'Create a 4-digit PIN to protect your transactions', kg: 'Операцияларды коргоо үчүн 4 орундуу PIN код түзүңүз' },
      confirmPin: { ru: 'Введите PIN-код ещё раз для подтверждения', en: 'Enter PIN code again to confirm', kg: 'Ырастоо үчүн PIN кодду кайра киргизиңиз' },
      pinSet: { ru: 'PIN-код успешно установлен!', en: 'PIN code set successfully!', kg: 'PIN код ийгиликтүү коюлду!' },
      pinError: { ru: 'Ошибка установки PIN', en: 'PIN setup error', kg: 'PIN коюу катасы' },
      pinMismatch: { ru: 'PIN-коды не совпадают', en: 'PIN codes do not match', kg: 'PIN коддор дал келбейт' },
    },
    language: {
      title: { ru: 'Язык', en: 'Language', kg: 'Тил' },
      select: { ru: 'Выберите язык', en: 'Select language', kg: 'Тилди тандаңыз' },
      russian: { ru: 'Русский', en: 'Russian', kg: 'Орусча' },
      english: { ru: 'English', en: 'English', kg: 'Англисче' },
      kyrgyz: { ru: 'Кыргызча', en: 'Kyrgyz', kg: 'Кыргызча' },
    },
  },
  
  // ===== Support =====
  support: {
    title: { ru: 'ПОДДЕРЖКА', en: 'SUPPORT', kg: 'КОЛДОО' },
    aiAssistant: { ru: 'AI-ассистент поддержки', en: 'AI Support Assistant', kg: 'AI колдоо жардамчысы' },
    faq: { ru: 'Частые вопросы', en: 'FAQ', kg: 'Көп берилүүчү суроолор' },
    inDevelopment: { ru: 'Раздел в разработке', en: 'Section in development', kg: 'Бөлүм иштелип жатат' },
    chatGreeting: { 
      ru: 'Я AI-ассистент PolyTech Wallet. Могу помочь с:\n\n• Вопросами о кошельке и балансе\n• KYC верификацией\n• Обменом валют\n• Пополнением и выводом\n\nЗадайте ваш вопрос!', 
      en: 'I am PolyTech Wallet AI assistant. I can help with:\n\n• Wallet and balance questions\n• KYC verification\n• Currency exchange\n• Top-up and withdrawal\n\nAsk your question!', 
      kg: 'Мен PolyTech Wallet AI жардамчысымын. Мен төмөнкүлөр боюнча жардам бере алам:\n\n• Капчык жана баланс боюнча суроолор\n• KYC верификация\n• Валюта алмаштыруу\n• Толуктоо жана чыгаруу\n\nСуроонузду берип коюңуз!' 
    },
    typeMessage: { ru: 'Введите сообщение...', en: 'Type a message...', kg: 'Билдирүү жазыңыз...' },
    aiThinking: { ru: 'AI думает...', en: 'AI is thinking...', kg: 'AI ойлонуп жатат...' },
  },
  
  // ===== Information =====
  info: {
    title: { ru: 'ИНФОРМАЦИЯ', en: 'INFORMATION', kg: 'МААЛЫМАТ' },
    aboutService: { ru: 'О сервисе', en: 'About service', kg: 'Сервис жөнүндө' },
    aboutCompany: { ru: 'О компании', en: 'About company', kg: 'Компания жөнүндө' },
    tariffs: { ru: 'Тарифы и комиссии', en: 'Tariffs and fees', kg: 'Тарифтер жана комиссиялар' },
  },
  
  // ===== Legal Documents =====
  legal: {
    title: { ru: 'ПРАВОВЫЕ ДОКУМЕНТЫ', en: 'LEGAL DOCUMENTS', kg: 'УКУКТУК ДОКУМЕНТТЕР' },
    license: { ru: 'Лицензия', en: 'License', kg: 'Лицензия' },
    terms: { ru: 'Пользовательское соглашение', en: 'Terms of Service', kg: 'Колдонуу шарттары' },
    privacy: { ru: 'Политика конфиденциальности', en: 'Privacy Policy', kg: 'Купуялык саясаты' },
    aml: { ru: 'AML/KYC Политика', en: 'AML/KYC Policy', kg: 'AML/KYC Саясаты' },
    brokerLicense: { ru: 'Лицензия на брокерскую деятельность (PDF)', en: 'Broker License (PDF)', kg: 'Брокердик лицензия (PDF)' },
    dealerLicense: { ru: 'Лицензия на дилерскую деятельность (PDF)', en: 'Dealer License (PDF)', kg: 'Дилердик лицензия (PDF)' },
  },
  
  // ===== Top-up Page =====
  topup: {
    title: { ru: 'Пополнение', en: 'Top up', kg: 'Толуктоо' },
    enterAmount: { ru: 'Введите сумму', en: 'Enter amount', kg: 'Сумманы киргизиңиз' },
    min: { ru: 'Минимум', en: 'Minimum', kg: 'Минимум' },
    fee: { ru: 'Комиссия', en: 'Fee', kg: 'Комиссия' },
    toReceive: { ru: 'К зачислению', en: 'You will receive', kg: 'Алаасыз' },
    bankTransfer: { ru: 'Банковский перевод', en: 'Bank transfer', kg: 'Банк которуусу' },
    paymentDetails: { ru: 'Реквизиты для оплаты', en: 'Payment details', kg: 'Төлөм реквизиттери' },
    bank: { ru: 'Банк', en: 'Bank', kg: 'Банк' },
    account: { ru: 'Счёт', en: 'Account', kg: 'Эсеп' },
    bik: { ru: 'БИК', en: 'BIC', kg: 'БИК' },
    recipient: { ru: 'Получатель', en: 'Recipient', kg: 'Алуучу' },
    inn: { ru: 'ИНН', en: 'Tax ID', kg: 'ИНН' },
    purpose: { ru: 'Назначение платежа', en: 'Payment purpose', kg: 'Төлөмдүн максаты' },
    afterPayment: { ru: 'После оплаты отправьте чек в поддержку для быстрого зачисления', en: 'After payment, send receipt to support for faster processing', kg: 'Төлөөдөн кийин тез иштетүү үчүн квитанцияны колдоого жөнөтүңүз' },
    copyDetails: { ru: 'Копировать реквизиты', en: 'Copy details', kg: 'Реквизиттерди көчүрүү' },
    detailsCopied: { ru: 'Реквизиты скопированы', en: 'Details copied', kg: 'Реквизиттер көчүрүлдү' },
  },
  
  // ===== Exchange Page =====
  exchange: {
    title: { ru: 'Обмен валюты', en: 'Currency Exchange', kg: 'Валюта алмаштыруу' },
    from: { ru: 'Отдаёте', en: 'You give', kg: 'Бересиз' },
    to: { ru: 'Получаете', en: 'You receive', kg: 'Аласыз' },
    rate: { ru: 'Курс', en: 'Rate', kg: 'Курс' },
    exchangeButton: { ru: 'Обменять', en: 'Exchange', kg: 'Айырбаштоо' },
    insufficientFunds: { ru: 'Недостаточно средств', en: 'Insufficient funds', kg: 'Каражат жетишсиз' },
    minAmount: { ru: 'Минимальная сумма', en: 'Minimum amount', kg: 'Минималдуу сумма' },
    exchangeSuccess: { ru: 'Обмен успешно выполнен!', en: 'Exchange completed successfully!', kg: 'Алмашуу ийгиликтүү аяктады!' },
    exchangeError: { ru: 'Ошибка обмена', en: 'Exchange error', kg: 'Алмашуу катасы' },
  },
  
  // ===== Withdraw Page =====
  withdraw: {
    title: { ru: 'Вывод средств', en: 'Withdraw', kg: 'Каражат чыгаруу' },
    selectMethod: { ru: 'Выберите способ вывода', en: 'Select withdrawal method', kg: 'Чыгаруу ыкмасын тандаңыз' },
    toCard: { ru: 'На карту', en: 'To card', kg: 'Картага' },
    bankTransfer: { ru: 'Банковский перевод', en: 'Bank transfer', kg: 'Банк которуусу' },
    cardNumber: { ru: 'Номер карты', en: 'Card number', kg: 'Карта номери' },
    holderName: { ru: 'Имя владельца', en: 'Cardholder name', kg: 'Кармоочунун аты' },
    amount: { ru: 'Сумма', en: 'Amount', kg: 'Сумма' },
    processing: { ru: 'Обработка вывода может занять до 24 часов', en: 'Withdrawal processing may take up to 24 hours', kg: 'Чыгарууну иштетүү 24 саатка чейин созулушу мүмкүн' },
    withdrawButton: { ru: 'Вывести', en: 'Withdraw', kg: 'Чыгаруу' },
    withdrawSuccess: { ru: 'Заявка на вывод создана', en: 'Withdrawal request created', kg: 'Чыгаруу өтүнүчү түзүлдү' },
    withdrawError: { ru: 'Ошибка вывода', en: 'Withdrawal error', kg: 'Чыгаруу катасы' },
    kycRequired: { ru: 'Для вывода необходимо пройти KYC верификацию', en: 'KYC verification required for withdrawal', kg: 'Чыгаруу үчүн KYC верификация талап кылынат' },
  },
  
  // ===== History Page =====
  history: {
    title: { ru: 'История операций', en: 'Transaction History', kg: 'Операциялар тарыхы' },
    all: { ru: 'Все', en: 'All', kg: 'Баары' },
    topups: { ru: 'Пополнения', en: 'Top-ups', kg: 'Толуктоолор' },
    withdrawals: { ru: 'Выводы', en: 'Withdrawals', kg: 'Чыгаруулар' },
    exchanges: { ru: 'Обмены', en: 'Exchanges', kg: 'Алмашуулар' },
    noHistory: { ru: 'История операций пуста', en: 'No transaction history', kg: 'Операциялар тарыхы бош' },
    transactionTypes: {
      topup: { ru: 'Пополнение', en: 'Top-up', kg: 'Толуктоо' },
      withdraw: { ru: 'Вывод', en: 'Withdrawal', kg: 'Чыгаруу' },
      exchange: { ru: 'Обмен', en: 'Exchange', kg: 'Алмашуу' },
    },
    statuses: {
      completed: { ru: 'Выполнено', en: 'Completed', kg: 'Аткарылды' },
      pending: { ru: 'В ожидании', en: 'Pending', kg: 'Күтүүдө' },
      processing: { ru: 'Обработка', en: 'Processing', kg: 'Иштетилүүдө' },
      failed: { ru: 'Ошибка', en: 'Failed', kg: 'Ката' },
      canceled: { ru: 'Отменено', en: 'Canceled', kg: 'Жокко чыгарылды' },
    },
  },
  
  // ===== Payments Page =====
  payments: {
    title: { ru: 'Платежи', en: 'Payments', kg: 'Төлөмдөр' },
    mobileTopup: { ru: 'Пополнение мобильной связи', en: 'Mobile top-up', kg: 'Мобилдик байланышты толуктоо' },
    selectOperator: { ru: 'Выберите оператора', en: 'Select operator', kg: 'Операторду тандаңыз' },
    phoneNumber: { ru: 'Номер телефона', en: 'Phone number', kg: 'Телефон номери' },
    paymentSuccess: { ru: 'Платёж успешно выполнен', en: 'Payment successful', kg: 'Төлөм ийгиликтүү аткарылды' },
    paymentError: { ru: 'Ошибка платежа', en: 'Payment error', kg: 'Төлөм катасы' },
  },
  
  // ===== Auth =====
  auth: {
    login: { ru: 'Вход', en: 'Login', kg: 'Кирүү' },
    register: { ru: 'Регистрация', en: 'Registration', kg: 'Каттоо' },
    phoneNumber: { ru: 'Номер телефона', en: 'Phone number', kg: 'Телефон номери' },
    password: { ru: 'Пароль', en: 'Password', kg: 'Сыр сөз' },
    confirmPassword: { ru: 'Подтвердите пароль', en: 'Confirm password', kg: 'Сыр сөздү ырастаңыз' },
    createPassword: { ru: 'Придумайте пароль', en: 'Create password', kg: 'Сыр сөз түзүңүз' },
    name: { ru: 'Имя', en: 'Name', kg: 'Аты' },
    enterName: { ru: 'Введите имя', en: 'Enter your name', kg: 'Атыңызды киргизиңиз' },
    loginButton: { ru: 'Войти', en: 'Log in', kg: 'Кирүү' },
    registerButton: { ru: 'Зарегистрироваться', en: 'Sign up', kg: 'Катталуу' },
    noAccount: { ru: 'Нет аккаунта? Зарегистрироваться', en: "Don't have an account? Sign up", kg: 'Аккаунт жокпу? Катталуу' },
    hasAccount: { ru: 'Уже есть аккаунт? Войти', en: 'Already have an account? Log in', kg: 'Аккаунтуңуз барбы? Кирүү' },
    have_account: { ru: 'Уже есть аккаунт? Войти', en: 'Already have an account? Log in', kg: 'Аккаунтуңуз барбы? Кирүү' },
    create_password: { ru: 'Придумайте пароль', en: 'Create password', kg: 'Сыр сөз түзүңүз' },
    orUseTelegram: { ru: 'Или используйте бот @polytech_wallet_bot в Telegram', en: 'Or use bot @polytech_wallet_bot in Telegram', kg: 'Же Telegram\'да @polytech_wallet_bot ботун колдонуңуз' },
    passwordsNotMatch: { ru: 'Пароли не совпадают', en: 'Passwords do not match', kg: 'Сыр сөздөр дал келбейт' },
    minPassword: { ru: 'Пароль минимум 6 символов', en: 'Password minimum 6 characters', kg: 'Сыр сөз минимум 6 символ' },
    enterPhone: { ru: 'Введите номер телефона', en: 'Enter phone number', kg: 'Телефон номерин киргизиңиз' },
    registrationSuccess: { ru: 'Регистрация успешна!', en: 'Registration successful!', kg: 'Каттоо ийгиликтүү!' },
    loginSuccess: { ru: 'Вход успешен!', en: 'Login successful!', kg: 'Кирүү ийгиликтүү!' },
    invalidCredentials: { ru: 'Неверный телефон или пароль', en: 'Invalid phone or password', kg: 'Телефон же сыр сөз туура эмес' },
    phoneExists: { ru: 'Этот номер уже зарегистрирован', en: 'This phone is already registered', kg: 'Бул номер мурунтан катталган' },
    countryCode: { ru: 'Код страны', en: 'Country code', kg: 'Өлкө коду' },
    searchCountry: { ru: 'Поиск страны...', en: 'Search country...', kg: 'Өлкө издөө...' },
  },
  
  // ===== Notifications =====
  notifications: {
    title: { ru: 'Уведомления', en: 'Notifications', kg: 'Билдирүүлөр' },
    noNotifications: { ru: 'Нет новых уведомлений', en: 'No new notifications', kg: 'Жаңы билдирүүлөр жок' },
    markAllRead: { ru: 'Отметить все как прочитанные', en: 'Mark all as read', kg: 'Баарын окулду деп белгилөө' },
  },
  
  // ===== Errors =====
  errors: {
    connectionError: { ru: 'Ошибка подключения', en: 'Connection error', kg: 'Байланыш катасы' },
    serverError: { ru: 'Ошибка сервера', en: 'Server error', kg: 'Сервер катасы' },
    tryAgain: { ru: 'Попробуйте позже', en: 'Try again later', kg: 'Кийинчерээк аракет кылыңыз' },
    somethingWrong: { ru: 'Что-то пошло не так', en: 'Something went wrong', kg: 'Бир нерсе туура эмес болду' },
    loadingError: { ru: 'Ошибка загрузки данных', en: 'Data loading error', kg: 'Маалымат жүктөө катасы' },
  },
  
  // ===== General =====
  general: {
    loading: { ru: 'Загрузка...', en: 'Loading...', kg: 'Жүктөлүүдө...' },
    version: { ru: 'Версия', en: 'Version', kg: 'Версия' },
    copyright: { ru: '© 2026 ОсОО «ФВА Финанс»', en: '© 2026 FVA Finance LLC', kg: '© 2026 ЖЧК «ФВА Финанс»' },
    updated: { ru: 'Обновлено', en: 'Updated', kg: 'Жаңыртылды' },
  },
  
  // ===== MIA Page =====
  mia: {
    title: { ru: 'MIA QR Платежи', en: 'MIA QR Payments', kg: 'MIA QR Төлөмдөр' },
    description: { ru: 'Пополнение через систему MIA', en: 'Top-up via MIA system', kg: 'MIA системасы аркылуу толуктоо' },
    scanQR: { ru: 'Отсканируйте QR-код', en: 'Scan QR code', kg: 'QR-кодду сканерлеңиз' },
  },
  
  // ===== Landing Page =====
  landing: {
    licensedBroker: { ru: 'Лицензированный валютный брокер', en: 'Licensed currency broker', kg: 'Лицензиялуу валюта брокери' },
    heroTitle: { ru: 'Обменивай валюту', en: 'Exchange currency', kg: 'Валюта алмаштыр' },
    heroSubtitle: { ru: 'быстро и безопасно', en: 'fast and secure', kg: 'тез жана коопсуз' },
    heroDescription: { ru: 'Покупайте и продавайте валюту. Мгновенный обмен, низкие комиссии, полная легальность по законодательству Кыргызстана.', en: 'Buy and sell currency. Instant exchange, low fees, fully legal under Kyrgyzstan law.', kg: 'Валюта сатып алыңыз жана сатыңыз. Тез алмашуу, төмөн комиссиялар, Кыргызстандын мыйзамдары боюнча толук мыйзамдуу.' },
    features: { ru: 'Функционал', en: 'Features', kg: 'Функциялар' },
    security: { ru: 'Безопасность', en: 'Security', kg: 'Коопсуздук' },
    faq: { ru: 'FAQ', en: 'FAQ', kg: 'КБС' },
    documents: { ru: 'Документы', en: 'Documents', kg: 'Документтер' },
    contacts: { ru: 'Контакты', en: 'Contacts', kg: 'Байланыштар' },
    openWallet: { ru: 'Открыть кошелёк', en: 'Open wallet', kg: 'Капчыкты ачуу' },
    webVersion: { ru: 'Web-версия', en: 'Web version', kg: 'Веб-версия' },
    exchangeTime: { ru: 'Время обмена', en: 'Exchange time', kg: 'Алмашуу убактысы' },
    commission: { ru: 'Комиссия', en: 'Commission', kg: 'Комиссия' },
    support247: { ru: 'Поддержка', en: 'Support', kg: 'Колдоо' },
    legal: { ru: 'Легально', en: 'Legal', kg: 'Мыйзамдуу' },
    allFunctionsInOne: { ru: 'Весь функционал в одном месте', en: 'All functions in one place', kg: 'Бардык функциялар бир жерде' },
    buyAndSell: { ru: 'Покупайте, продавайте и обменивайте валюту без сложностей', en: 'Buy, sell and exchange currency without complications', kg: 'Кыйынчылыксыз валюта сатып алыңыз, сатыңыз жана алмаштырыңыз' },
    cardTopup: { ru: 'Пополнение картой', en: 'Card top-up', kg: 'Карта менен толуктоо' },
    cardTopupDesc: { ru: 'Мгновенное пополнение баланса через Visa, MasterCard или MIA QR', en: 'Instant balance top-up via Visa, MasterCard or MIA QR', kg: 'Visa, MasterCard же MIA QR аркылуу тез баланс толуктоо' },
    onlineExchange: { ru: 'Обмен онлайн', en: 'Online exchange', kg: 'Онлайн алмашуу' },
    onlineExchangeDesc: { ru: 'Быстрый обмен вашей валюты на доллары и обратно по выгодному курсу', en: 'Fast exchange of your currency to dollars and back at favorable rates', kg: 'Валютаңызды долларга жана артка жакшы курс менен тез алмашуу' },
    cardWithdrawal: { ru: 'Вывод на карту', en: 'Card withdrawal', kg: 'Картага чыгаруу' },
    cardWithdrawalDesc: { ru: 'Продавайте валюту и получайте средства на банковскую карту', en: 'Sell currency and receive funds to your bank card', kg: 'Валюта сатып, банк картаңызга каражат алыңыз' },
    mobilePayments: { ru: 'Мобильные платежи', en: 'Mobile payments', kg: 'Мобилдик төлөмдөр' },
    mobilePaymentsDesc: { ru: 'Пополнение мобильной связи прямо из кошелька', en: 'Mobile top-up directly from wallet', kg: 'Капчыктан түз эле мобилдик байланышты толуктоо' },
    kycVerification: { ru: 'KYC Верификация', en: 'KYC Verification', kg: 'KYC Верификация' },
    kycVerificationDesc: { ru: 'Безопасная верификация для полного функционала', en: 'Secure verification for full functionality', kg: 'Толук функционал үчүн коопсуз верификация' },
    referralProgram: { ru: 'Реферальная программа', en: 'Referral program', kg: 'Реферралдык программа' },
    referralProgramDesc: { ru: 'Приглашайте друзей и получайте до 30% от комиссии', en: 'Invite friends and get up to 30% commission', kg: 'Досторуңузду чакырыңыз жана 30%ка чейин комиссия алыңыз' },
    howItWorks: { ru: 'Как это работает', en: 'How it works', kg: 'Бул кандай иштейт' },
    threeSimpleSteps: { ru: 'Три простых шага для начала работы', en: 'Three simple steps to get started', kg: 'Баштоо үчүн үч жөнөкөй кадам' },
    step1Title: { ru: 'Откройте кошелёк', en: 'Open wallet', kg: 'Капчыкты ачыңыз' },
    step1Desc: { ru: 'Запустите бота @polytech_wallet_bot в Telegram или откройте веб-версию', en: 'Launch @polytech_wallet_bot in Telegram or open web version', kg: 'Telegram\'да @polytech_wallet_bot ботун иштетиңиз же веб-версияны ачыңыз' },
    step2Title: { ru: 'Пополните баланс', en: 'Top up balance', kg: 'Балансты толуктоо' },
    step2Desc: { ru: 'Внесите средства через Visa, MasterCard или MIA QR', en: 'Add funds via Visa, MasterCard or MIA QR', kg: 'Visa, MasterCard же MIA QR аркылуу каражат салыңыз' },
    step3Title: { ru: 'Используйте', en: 'Use', kg: 'Колдонуңуз' },
    step3Desc: { ru: 'Обменивайте, переводите или выводите средства на карту', en: 'Exchange, transfer or withdraw to card', kg: 'Алмаштырыңыз, которуңуз же картага чыгарыңыз' },
    securityFirst: { ru: 'Безопасность на первом месте', en: 'Security first', kg: 'Биринчи орунда коопсуздук' },
    modernTech: { ru: 'Современные технологии защиты ваших средств', en: 'Modern technologies to protect your funds', kg: 'Каражатыңызды коргоо үчүн заманбап технологиялар' },
    pinProtection: { ru: 'PIN-код', en: 'PIN code', kg: 'PIN код' },
    pinProtectionDesc: { ru: 'Защита операций PIN-кодом', en: 'Operation protection with PIN', kg: 'PIN код менен операцияларды коргоо' },
    kycSecurity: { ru: 'KYC', en: 'KYC', kg: 'KYC' },
    kycSecurityDesc: { ru: 'Верификация личности', en: 'Identity verification', kg: 'Инсандыкты текшерүү' },
    amlSecurity: { ru: 'AML', en: 'AML', kg: 'AML' },
    amlSecurityDesc: { ru: 'Проверка транзакций', en: 'Transaction verification', kg: 'Транзакцияларды текшерүү' },
    licenseSecurity: { ru: 'Лицензия', en: 'License', kg: 'Лицензия' },
    licenseSecurityDesc: { ru: 'Легальная деятельность', en: 'Legal activity', kg: 'Мыйзамдуу иш-аракет' },
    frequentQuestions: { ru: 'Частые вопросы', en: 'FAQ', kg: 'КБС' },
    legalDocuments: { ru: 'Юридические документы', en: 'Legal documents', kg: 'Укуктук документтер' },
    workingLegally: { ru: 'Мы работаем в соответствии с законодательством Кыргызской Республики', en: 'We operate in accordance with the laws of the Kyrgyz Republic', kg: 'Биз Кыргыз Республикасынын мыйзамдарына ылайык иштейбиз' },
    allDocuments: { ru: 'Все документы', en: 'All documents', kg: 'Бардык документтер' },
    contactsTitle: { ru: 'Контакты', en: 'Contacts', kg: 'Байланыштар' },
    contactUs: { ru: 'Свяжитесь с нами любым удобным способом', en: 'Contact us in any convenient way', kg: 'Биз менен ыңгайлуу жол менен байланышыңыз' },
    telegramSupport: { ru: 'Telegram поддержка', en: 'Telegram support', kg: 'Telegram колдоо' },
    address: { ru: 'Адрес', en: 'Address', kg: 'Дарек' },
    startExchangingToday: { ru: 'Начните обменивать валюту уже сегодня', en: 'Start exchanging currency today', kg: 'Бүгүн валюта алмаштырууну баштаңыз' },
    joinUsers: { ru: 'Присоединяйтесь к тысячам пользователей PolyTech Wallet', en: 'Join thousands of PolyTech Wallet users', kg: 'PolyTech Wallet миңдеген колдонуучуларына кошулуңуз' },
    openInTelegram: { ru: 'Открыть в Telegram', en: 'Open in Telegram', kg: 'Telegram\'да ачуу' },
    wallet: { ru: 'Кошелёк', en: 'Wallet', kg: 'Капчык' },
    company: { ru: 'Компания', en: 'Company', kg: 'Компания' },
    supportFooter: { ru: 'Поддержка', en: 'Support', kg: 'Колдоо' },
    allRightsReserved: { ru: 'Все права защищены', en: 'All rights reserved', kg: 'Бардык укуктар корголгон' },
  },
  
  // ===== FAQ Section =====
  faq: {
    q1: { 
      ru: 'Как начать пользоваться PolyTech Wallet?', 
      en: 'How to start using PolyTech Wallet?', 
      kg: 'PolyTech Wallet колдонууну кантип баштоо керек?' 
    },
    a1: { 
      ru: 'Откройте Telegram, найдите бота @polytechex_bot и нажмите "Начать". Вы также можете использовать веб-версию кошелька по адресу нашего сайта.', 
      en: 'Open Telegram, find the @polytechex_bot and press "Start". You can also use the web version of the wallet on our website.', 
      kg: 'Telegram ачыңыз, @polytechex_bot ботун таап, "Баштоо" баскычын басыңыз. Сиз ошондой эле биздин веб-сайттагы капчыктын веб-версиясын колдоно аласыз.' 
    },
    q2: { 
      ru: 'Какие комиссии за операции?', 
      en: 'What are the fees for transactions?', 
      kg: 'Операциялар үчүн комиссиялар кандай?' 
    },
    a2: { 
      ru: 'Комиссия за покупку USD составляет 1.7%, за продажу — 1%. Комиссия уже включена в отображаемый курс.', 
      en: 'The fee for buying USD is 1.7%, for selling — 1%. The fee is already included in the displayed rate.', 
      kg: 'USD сатып алуу комиссиясы 1.7%, сатуу — 1%. Комиссия көрсөтүлгөн курска мурунтан эле кирген.' 
    },
    q3: { 
      ru: 'Как долго идёт зачисление?', 
      en: 'How long does the deposit take?', 
      kg: 'Эсепке салуу канча убакыт талап кылат?' 
    },
    a3: { 
      ru: 'После подтверждения платежа, средства зачисляются на баланс в течение нескольких минут.', 
      en: 'After payment confirmation, funds are credited to the balance within a few minutes.', 
      kg: 'Төлөмдү ырастагандан кийин, каражаттар бир нече мүнөттүн ичинде балансыңызга чегерилет.' 
    },
    q4: { 
      ru: 'Нужна ли верификация?', 
      en: 'Is verification required?', 
      kg: 'Верификация керекпи?' 
    },
    a4: { 
      ru: 'Для базовых операций верификация не требуется. KYC необходим для снятия лимитов и доступа к расширенному функционалу.', 
      en: 'Verification is not required for basic operations. KYC is needed to lift limits and access extended features.', 
      kg: 'Негизги операциялар үчүн верификация талап кылынбайт. KYC чектөөлөрдү алып салуу жана кеңейтилген функцияларга жетүү үчүн керек.' 
    },
    q5: { 
      ru: 'Это легально?', 
      en: 'Is this legal?', 
      kg: 'Бул мыйзамдуубу?' 
    },
    a5: { 
      ru: 'Да, PolyTech Wallet работает в соответствии с законодательством Кыргызской Республики и имеет лицензию на осуществление брокерской и дилерской деятельности на рынке ценных бумаг.', 
      en: 'Yes, PolyTech Wallet operates in accordance with the laws of the Kyrgyz Republic and is licensed for brokerage and dealer activities in the securities market.', 
      kg: 'Ооба, PolyTech Wallet Кыргыз Республикасынын мыйзамдарына ылайык иштейт жана баалуу кагаздар рыногунда брокердик жана дилердик ишмердүүлүккө лицензиясы бар.' 
    },
    q6: { 
      ru: 'Какие лимиты на операции?', 
      en: 'What are the transaction limits?', 
      kg: 'Операциялар боюнча чектөөлөр кандай?' 
    },
    a6: { 
      ru: 'Минимальная сумма пополнения — 10 USD. Максимальная сумма одной операции — 5 000 USD. Лимиты могут быть увеличены после прохождения KYC.', 
      en: 'Minimum deposit amount is 10 USD. Maximum single transaction amount is 5,000 USD. Limits can be increased after KYC verification.', 
      kg: 'Минималдуу толуктоо суммасы — 10 USD. Бир операциянын максималдуу суммасы — 5 000 USD. KYC верификациясынан өткөндөн кийин чектөөлөр көбөйтүлүшү мүмкүн.' 
    },
  },
  
  // ===== Legal Documents =====
  docs: {
    license: { 
      title: { ru: 'Лицензия', en: 'License', kg: 'Лицензия' },
      desc: { ru: 'Лицензия на осуществление деятельности по обмену виртуальных активов', en: 'License for virtual asset exchange activities', kg: 'Виртуалдык активдерди алмаштыруу боюнча иш жүргүзүү лицензиясы' }
    },
    registration: { 
      title: { ru: 'Свидетельство о регистрации', en: 'Registration Certificate', kg: 'Каттоо күбөлүгү' },
      desc: { ru: 'Свидетельство о государственной регистрации юридического лица', en: 'Certificate of state registration of a legal entity', kg: 'Юридикалык жактын мамлекеттик каттоо күбөлүгү' }
    },
    amlPolicy: { 
      title: { ru: 'Политика AML/KYC', en: 'AML/KYC Policy', kg: 'AML/KYC Саясаты' },
      desc: { ru: 'Политика противодействия отмыванию денег и финансированию терроризма', en: 'Anti-money laundering and counter-terrorism financing policy', kg: 'Акча жуугандыкка жана терроризмди каржылоого каршы саясат' }
    },
    userAgreement: { 
      title: { ru: 'Пользовательское соглашение', en: 'User Agreement', kg: 'Колдонуучу келишими' },
      desc: { ru: 'Условия использования сервиса PolyTech Wallet', en: 'Terms of use for PolyTech Wallet service', kg: 'PolyTech Wallet кызматын колдонуу шарттары' }
    },
    privacyPolicy: { 
      title: { ru: 'Политика конфиденциальности', en: 'Privacy Policy', kg: 'Купуялык саясаты' },
      desc: { ru: 'Порядок обработки и защиты персональных данных', en: 'Personal data processing and protection procedures', kg: 'Жеке маалыматтарды иштетүү жана коргоо тартиби' }
    },
    registryExtract: { 
      title: { ru: 'Выписка из реестра', en: 'Registry Extract', kg: 'Реестрден көчүрмө' },
      desc: { ru: 'Выписка из единого государственного реестра юридических лиц', en: 'Extract from the unified state register of legal entities', kg: 'Юридикалык жактардын бирдиктүү мамлекеттик реестринен көчүрмө' }
    },
    companyInfo: { 
      ru: 'ОсОО «ФВА Финанс» — лицензированный брокер и дилер на рынке ценных бумаг Кыргызской Республики.',
      en: 'FVA Finance LLC — licensed broker and dealer in the securities market of the Kyrgyz Republic.',
      kg: 'ЖЧК «ФВА Финанс» — Кыргыз Республикасынын баалуу кагаздар рыногунда лицензияланган брокер жана дилер.'
    },
    licenseNumbers: { 
      ru: 'Лицензии № 159, № 160', 
      en: 'Licenses No. 159, No. 160', 
      kg: 'Лицензиялар № 159, № 160' 
    },
  },
};

// Helper function to get translation
export const getTranslation = (key, lang = 'ru') => {
  const keys = key.split('.');
  let result = translations;
  
  for (const k of keys) {
    if (result && result[k]) {
      result = result[k];
    } else {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
  }
  
  if (typeof result === 'object' && result[lang]) {
    return result[lang];
  }
  
  return key;
};

// Export default language
export const defaultLanguage = 'ru';

// Supported languages
export const supportedLanguages = [
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'kg', name: 'Кыргызча', flag: '🇰🇬' },
];
